import './TextFilter.css';
import React, { useEffect, useRef, useState } from 'react';
import { useSitecoreContext } from '../../utils/SitecoreContextReactContext';
import { useHistory } from "react-router-dom";
import addQueryString, { removeQueryString } from "./index";
import { qsToObject } from "../../utils/querystring";
import { get } from '../../utils';
import { tealiumClickFunc, tealiumMergeClickData } from "../../utils/tealium";
import getListing from '../../utils/getListing';
const SuggestionsList = _ref => {
  let {
    suggestionList,
    setIsOpen,
    sendRequestHandler,
    analytics,
    fields
  } = _ref;
  const drop = React.useRef(null);
  const filterName = get(fields, 'name');
  const handleOutClick = _ref2 => {
    let {
      target
    } = _ref2;
    if (!drop.current.contains(target)) {
      setIsOpen(false);
    }
  };
  const handleItemClick = title => {
    sendRequestHandler(title);
    setIsOpen(false);
    tealiumClickFunc(tealiumMergeClickData(analytics.filterAnalytics, analytics.params), `${filterName} : ${title}`);
  };
  React.useEffect(() => {
    document.body.addEventListener('click', handleOutClick);
    return () => document.body.removeEventListener('click', handleOutClick);
  }, []);
  return /*#__PURE__*/React.createElement("ul", {
    className: "suggestions-list text-filter",
    ref: drop
  }, suggestionList.map(suggestion => {
    return /*#__PURE__*/React.createElement("li", {
      tabIndex: 0,
      className: "suggestion-item",
      onClick: () => handleItemClick(suggestion.title),
      onKeyPress: event => {
        if (event.key === "Enter" || event.key === "NumpadEnter") {
          event.preventDefault();
          event.target.click();
        }
      }
    }, suggestion.title);
  }));
};
const TextFilter = _ref3 => {
  let {
    fields,
    params,
    showLabel,
    resultsLabel,
    clearAllLabel,
    facets,
    nbHits,
    setFilter,
    facetsName,
    fullWidth,
    indexDropDown,
    firstQuery,
    firstFilter,
    wrapperToggle,
    defaultFacets,
    setSubpanelLabel,
    clearAlllFilters,
    rtl,
    analytics,
    getFilterValue,
    columnsClass = 'col-md-4'
  } = _ref3;
  const sitecoreContext = useSitecoreContext();
  const algoliaSettings = {
    key: get(sitecoreContext, 'configuration.algolia.algoliaApiKey'),
    id: get(sitecoreContext, 'configuration.algolia.algoliaApplicationId'),
    fullTextSearchIndex: get(sitecoreContext, 'configuration.algolia.fullTextSearchIndex')
  };
  let history = useHistory();
  const label = get(fields, 'title.jss.value');
  const [suggestionList, setSuggestionList] = React.useState([]);
  const [isOpen, setIsOpen] = React.useState(false);
  const borderRadius = {
    borderRadius: '4px 4px 0 0'
  };
  const [value, setValue] = React.useState('');
  const [hits, setHits] = React.useState([]);
  const [highLightText, setHighLightText] = useState(false);
  const clickedTextRef = useRef(false);
  const algoliaIndex = get(params, 'SearchIndex');
  useEffect(() => {
    const itemFilters = {
      query: value
    };
    getListing(algoliaIndex, itemFilters, algoliaSettings).then(response => {
      setHits(response.hits);
    });
  }, [value]);
  const inputHandler = _ref4 => {
    let {
      target
    } = _ref4;
    setIsOpen(true);
    const list = hits.filter(_ref5 => {
      let {
        title
      } = _ref5;
      return target.value && ~title.toString().toLowerCase().indexOf(target.value.toLowerCase());
    });
    setSuggestionList(list);
    setValue(target.value);
  };
  const sendRequestHandler = title => {
    setValue(title);
    getFilterValue && getFilterValue(fields.name, facetsName, title);
    addQueryString(facetsName, title, history);
    setFilter(title);
  };
  const clearFilter = () => {
    setValue('');
    removeQueryString(facetsName, history);
    getFilterValue && getFilterValue(fields.name, facetsName, null);
  };
  React.useEffect(() => {
    if (clearAlllFilters) {
      clearFilter();
    }
  }, [clearAlllFilters]);
  React.useEffect(() => {
    if (typeof window !== "undefined") {
      const urlParams = qsToObject(window.location.href);
      const title = urlParams['title'];
      if (title) {
        setValue(title.split('+').join(' '));
      }
    }
  }, []);
  const handleTextBlur = () => {
    clickedTextRef.current = false;
    setHighLightText(false);
  };
  const handleTextMousedown = () => {
    clickedTextRef.current = true;
  };
  const handleTextFocus = () => {
    if (!clickedTextRef.current) {
      setHighLightText(true);
    }
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    fullWidth: fullWidth,
    columnsClass: columnsClass
  }, /*#__PURE__*/React.createElement("div", {
    className: "filter__field "
  }, /*#__PURE__*/React.createElement("div", {
    className: "input-search-box"
  }, /*#__PURE__*/React.createElement("input", {
    type: "text",
    className: `
                        input-text-primary
                        input-search-text
                        ${highLightText ? 'input-text-primary--focused' : ''}
                        ${isOpen ? 'input-search-text--openedDrop' : ''}
                      `,
    placeholder: label,
    style: isOpen && suggestionList.length ? borderRadius : undefined,
    value: value,
    onChange: inputHandler,
    onClick: () => setIsOpen(true),
    onMouseDown: handleTextMousedown,
    onFocus: handleTextFocus,
    onBlur: handleTextBlur
  }), /*#__PURE__*/React.createElement("span", {
    className: `search-icon ${rtl ? 'search-icon-left' : 'search-icon-right'}`
  })), isOpen && /*#__PURE__*/React.createElement(SuggestionsList, {
    suggestionList: suggestionList,
    setIsOpen: setIsOpen,
    sendRequestHandler: sendRequestHandler,
    fields: fields,
    analytics: analytics
  })));
};
const StyledWrapper = _ref6 => {
  let {
    children,
    fullWidth,
    columnsClass
  } = _ref6;
  return /*#__PURE__*/React.createElement("div", {
    className: `${commonStyles} ${fullWidth ? 'col-12' : columnsClass}`
  }, children);
};

// export default DropDown;
export default TextFilter;
const commonStyles = "c8zaogd";